import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { or, eq, not, and } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { pick } from 'teacher-ui-client/helpers/pick'
import type SchoolClass from 'teacher-ui-client/models/school-class'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import type { AdditionalClassSelectOption } from 'teacher-ui-client/components/base/select/school-class/options'
import { BaseSelect } from 'teacher-ui-client/components/base/select'

interface Signature {
  Element: HTMLSelectElement
  Args: {
    placeholder?: string
    additionalOptions?: AdditionalClassSelectOption[]
    schoolClasses: SchoolClass[]
    schoolClassId?: string
    updateSchoolClassId: (schoolClassId: string) => unknown
    themeKey?: ThemeKeys
  }
  Blocks: {
    default: []
  }
}
// A themed select component.
// Uses native select hence does not support styling of options.
export const SchoolClassSelect: TOC<Signature> = <template>
  <BaseSelect
    data-test-school-class-select
    @themeKey={{@themeKey}}
    {{on "input" (pick "target.value" @updateSchoolClassId)}}
    ...attributes
  >
    {{#if (and @placeholder (not @schoolClassId))}}
      <option value="" selected={{not @schoolClassId}} disabled={{@schoolClassId}}>{{@placeholder}}</option>
    {{/if}}
    {{#each @additionalOptions as |optionItem|}}
      <option value={{optionItem.id}} selected={{eq @schoolClassId optionItem.id}}>
        {{or optionItem.label (if optionItem.labelKey (t optionItem.labelKey))}}
      </option>
    {{/each}}
    <optgroup label={{t "base.select.schoolClasses"}}>
      {{#each @schoolClasses as |schoolClass|}}
        <option value={{schoolClass.id}} selected={{eq @schoolClassId schoolClass.id}}>{{schoolClass.name}}</option>
      {{/each}}
    </optgroup>
  </BaseSelect>
</template>

export default SchoolClassSelect
